module.exports = __webpack_public_path__ + "img/logo_2@2x.c248ae66.png";